import React from 'react';

const ListMedia = (props) => {
  const styleContents = {
    backgroundImage: `url(${props.el.imageUrl})`
  }

  return (
    <li className="ListMedia slideList">
      <div className="contents">
        <a href={props.el.url} target="_blank" rel="noopener noreferrer">
        {/* hover dim */}
        <div className="dim-gradient"></div>

        {/* image thumbnail */}
        <div className="image" style = {styleContents}></div>

        {/* list text */}
        <div className="wrap-text">
          <h5>{props.el.title}</h5>
          <p>{props.el.date}</p>
          <p>{props.el.source}</p>
        </div>
        </a>
      </div>
    </li>
  );
}

export default ListMedia;